function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M3 6.62646H5H21",
  stroke: "#767A8A",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M8 6.62646V4.62646C8 4.09603 8.21071 3.58732 8.58579 3.21225C8.96086 2.83718 9.46957 2.62646 10 2.62646H14C14.5304 2.62646 15.0391 2.83718 15.4142 3.21225C15.7893 3.58732 16 4.09603 16 4.62646V6.62646M19 6.62646V20.6265C19 21.1569 18.7893 21.6656 18.4142 22.0407C18.0391 22.4158 17.5304 22.6265 17 22.6265H7C6.46957 22.6265 5.96086 22.4158 5.58579 22.0407C5.21071 21.6656 5 21.1569 5 20.6265V6.62646H19Z",
  stroke: "#767A8A",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref4 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M10 11.6265V17.6265",
  stroke: "#767A8A",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref5 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("path", {
  d: "M14 11.6265V17.6265",
  stroke: "#767A8A",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
const SvgTrash = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTrash, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/trash.87f1f124.svg";
export { ForwardRef as ReactComponent };